<div class="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
  <div class="w-full max-w-md text-center">
    <p class="text-title-md font-semibold text-brand-500">403</p>
    <h1 class="mt-4 text-title-md font-bold text-gray-800 dark:text-white/90 sm:text-title-lg">
      {{ 'forbidden.title' | t }}
    </h1>
    <p class="mt-4 text-sm text-gray-500 dark:text-gray-400">
      {{ 'forbidden.message' | t }}
<!--      @if (user(); as u) {-->
<!--      <br />-->
<!--      Connecté en tant que <span class="font-medium text-gray-700 dark:text-gray-300">{{ u.displayName || u.username }}</span>-->
<!--      @if (roles().length) {-->
<!--      — rôles : <span class="font-medium text-gray-700 dark:text-gray-300">{{ roles().join(', ') }}</span>-->
<!--      }-->
<!--      }-->
    </p>
    <div class="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
      <a
        routerLink="/"
        class="inline-flex w-full items-center justify-center rounded-lg bg-brand-500 px-5 py-3 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600 sm:w-auto"
      >
        {{ 'forbidden.backToDashboard' | t }}
      </a>
      <button
        type="button"
        (click)="logout()"
        class="inline-flex w-full items-center justify-center rounded-lg border border-gray-300 px-5 py-3 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 sm:w-auto"
      >
        {{ 'common.logout' | t }}
      </button>
    </div>
  </div>
</div>
